module.exports = __webpack_public_path__ + "static/media/iStock-63.a530e62b.png";